import { DISABLE_TELEPHONE, SHOW_PHONE_OPT_OUT_CHECKBOX } from './PersonalInformationPageConstants';
import { PAGE_NAME } from '../../config/pageNames';
import { setServerData } from '../../../framework/store/ServerData/ServerDataActions';
import { spinnerClose } from '../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import axios from 'axios';
import _ from 'lodash';
import { push } from 'connected-react-router';
import { NETWORK } from '../../../framework/App/AppConstants';
import setUrl from '../../../framework/App/SetUrl';
import { APPLY_TYPE } from '../../USConstants';
import { SubmissionError } from 'redux-form';
import { handleServerSideErrors } from '../../utils/USUtils';


export const disableTelephone = (val) => {
    return {
        type: DISABLE_TELEPHONE,
        payload: val
    };
};

export const showPhoneOptOutCheckbox = (val) => {
    return {
        type: SHOW_PHONE_OPT_OUT_CHECKBOX,
        payload: val
    };
};

export const handleRedirect = response => {
    if (response && _.get(response, 'data.redirect')) {
        setUrl(window, response.data.redirect);
        return true;
    }
    return false;
};

/**
 * When AssetLite Phase 2 is on Treatment 1 then
 * On click of continue button in Personal info page, POST /personalinfopage
 * In applicationUS.js submitPersonalInfoReact(...) gets called
 *      CIS is called to check if existing credit account exists
 *          if existing credit account is found by CIS
 *              ACQSERV is called w/ LINK_APPLICATION
 *          else
 *              Terms page is shown
 * When on CONTROL then
 * On click of continue button in Personal info page, the next page Terms page is shown
 * @param data
 */
export const submitForCreditAccountIdentification = data => (dispatch, getState) => {
    const { serverData = {} } = getState();
    const { _csrf = '' } = serverData;
    return axios
        .request({
            url: PAGE_NAME.PERSONAL_INFO_PAGE,
            method: 'post',
            headers: {
                ...NETWORK.REQUEST.XHR.HEADER,
                'X-CSRF-Token': _csrf
            },
            data
        })
        .then(async(response) => {
            const isLinkApplicationFlow = _.get(response, 'data.linkApplicationFlow');
            capeLog && capeLog(`response:${isLinkApplicationFlow}`);
            window.applyType = (isLinkApplicationFlow) ? APPLY_TYPE.FAST : APPLY_TYPE.FULL;
            const appStatus = _.get(response, 'data.applicationStatus');
            capeLog && capeLog(`response:${appStatus}`);
            window.appStatus = appStatus;
            // handle server-side errors
            await handleServerSideErrors(dispatch, getState, response);
            //TODO re-evaluate if else logic needs this to be dispatched
            dispatch(setServerData({
                decisionModel: response.data,
                userLoggedIn: _.get(response, 'data.userLoggedIn')
            }));
            if (isLinkApplicationFlow) {
                dispatch(push(PAGE_NAME.DECISION_PAGE));
                dispatch(spinnerClose());
            } else {
                dispatch(spinnerClose());
                dispatch(push(PAGE_NAME.TERMS_PAGE));
            }
        })
        .catch(error => {
            // show server-side errors on form
            if (error instanceof SubmissionError) {
                return Promise.reject(error);
            }
            capeLog && capeLog('response:error: PersonalInformationPageAction return from ALP2' + (error && error.message));

            if (handleRedirect(error && error.response)) {
                return;
            }

            if (_.get(error, 'response.data.err', false)) {
                dispatch(setServerData({ errorModel: _.get(error, 'response.data', {}) }));
                dispatch(push(PAGE_NAME.ERROR_PAGE));
                dispatch(spinnerClose());
            } else {
                // should never be here
                capeLog && capeLog('response:error: unexpected error response for personal info page submit');
                setUrl(window, PAGE_NAME.ERROR_PAGE);
            }
        });
};


